import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { inviteAdmin, listAdmins } from "@/lib/admin.functions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Shield } from "lucide-react";

export const Route = createFileRoute("/_authenticated/gestion/admins")({
  component: AdminsPage,
});

function AdminsPage() {
  const list = useServerFn(listAdmins);
  const invite = useServerFn(inviteAdmin);
  const [admins, setAdmins] = useState<{ user_id: string; email: string | null; created_at: string }[]>([]);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function load() {
    try { setAdmins(await list()); } catch (e) { toast.error((e as Error).message); }
  }
  useEffect(() => { load(); }, []);

  async function handleInvite() {
    setLoading(true);
    try {
      await invite({ data: { email: email.trim(), password } });
      toast.success("Administrador creado");
      setOpen(false); setEmail(""); setPassword(""); load();
    } catch (e) { toast.error((e as Error).message); }
    finally { setLoading(false); }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Crea cuentas de administrador con acceso completo al panel.</p>
        <Button onClick={() => setOpen(true)}><Plus className="mr-2 h-4 w-4" />Nuevo admin</Button>
      </div>

      <Card>
        <CardHeader><CardTitle className="font-serif text-base flex items-center gap-2"><Shield className="h-4 w-4" />Administradores actuales</CardTitle></CardHeader>
        <CardContent>
          <table className="w-full text-sm">
            <thead className="text-left text-xs uppercase text-muted-foreground"><tr><th className="py-2">Email</th><th>Alta</th></tr></thead>
            <tbody>
              {admins.map((a) => (
                <tr key={a.user_id} className="border-t"><td className="py-2">{a.email ?? a.user_id}</td><td>{new Date(a.created_at).toLocaleDateString()}</td></tr>
              ))}
              {admins.length === 0 && <tr><td colSpan={2} className="py-6 text-center text-muted-foreground">Cargando…</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-serif">Nuevo administrador</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <div><Label>Contraseña inicial</Label><Input type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 8 caracteres" /></div>
            <p className="text-xs text-muted-foreground">Comparte estas credenciales con la persona; podrá cambiarlas más adelante.</p>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={handleInvite} disabled={loading || !email || password.length < 8}>Crear</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}